import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import './navbar.css';
import { Link as Linker } from 'react-router-dom';
import { Link } from 'react-scroll';
import logo from '../../assets/logo.png';

const Menu = () => (
  <>
    <Linker className="hover:before:w-0 hover:cursor-pointer" to="/">
      <p>Home</p>
    </Linker>

    <p><Link to="about" smooth={true} duration={500}>About EduBahamas</Link></p>

    <p><Link to="home_subj" smooth={true} duration={500}>Subjects</Link></p>

    <p><Link to="resources" smooth={true} duration={500}>Learn Now</Link></p>
  </>
);

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  const closeMenu = () => setToggleMenu(false);

  return (
    <div className="edubahamas__navbar">
      {/* Logo Section */}
      <div className="edubahamas__navbar-links-logo">
        <Linker to="/" className="edubahamas__brand">
          <div 
            className="h-[60px] w-[60px] rounded-full flex items-center justify-center backdrop-blur-sm" 
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              boxShadow: '0 8px 32px 0 rgba(84, 179, 214, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.1)',
            }}
          >
            <img 
              src={logo} 
              alt="EduBahamas logo" 
              className="h-[45px] w-[45px] object-contain"
            />
          </div>
          <h1 className="logo">EduBahamas</h1>
        </Linker>
      </div>

      {/* Desktop Menu */}
      <div className="edubahamas__navbar-links-container">
        <Menu />
      </div>

      {/* Desktop Sign In/Register Buttons */}
      <div className="edubahamas__navbar-sign">
        <Linker to="/signIn">
          <button 
            type="button" 
            className="bg-transparent hover:cursor-pointer hover:text-[#1896b9] hover:bg-transparent transition duration-200 ease-in"
          >
            Sign In
          </button>
        </Linker>
        <Linker to="/register">
          <button 
            className="bg-[#1896b9] hover:bg-[#064759] transition duration-200 ease-in" 
            type="button"
          >
            Register
          </button>
        </Linker>
      </div>

      {/* Mobile Menu Toggle */}
      <div className="edubahamas__navbar-menu">
        {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={closeMenu} />
          : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />
        }
        
        {/* Mobile Menu Dropdown */}
        {toggleMenu && (
          <div className="edubahamas__navbar-menu-container scale-up-center">
            <div className="edubahamas__navbar-menu-container-links" onClick={closeMenu}>
              <Menu />
            </div>
            <div className="edubahamas__navbar-menu-container-links-sign">
              <Linker to="/signIn" onClick={closeMenu}>
                <button type="button">Sign In</button>
              </Linker>
              <Linker to="/register" onClick={closeMenu}>
                <button type="button">Register Now</button>
              </Linker>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;